import React from 'react';
import styled from 'styled-components';
import ArticlesWithFilter from '../components/ArticlesWithFilter';
import colors from '../theme/colors';

const PageContainer = styled.div`
  max-width: 1200px;
  margin: 0 auto;
  padding: 3rem 2rem;
  background-color: ${colors.lightGray};
  min-height: calc(100vh - 200px);
`;

const PageTitle = styled.h1`
  font-size: clamp(1.75rem, 4vw, 2.25rem);
  margin: 0 0 0.5rem 0;
  color: ${colors.mainBlack};
  font-weight: 700;
  letter-spacing: -0.02em;
  line-height: 1.25;
  background: ${colors.mainGradient};
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
`;

const PageDescription = styled.p`
  font-size: 1.125rem;
  color: ${colors.textGray};
  margin: 0 0 1.75rem 0;
  line-height: 1.6;
`;

const Categories: React.FC = () => {
  return (
    <PageContainer>
      <PageTitle>Категорії</PageTitle>
      <PageDescription>
        Перегляньте статті за категоріями. Оберіть категорію зі списку, щоб побачити відповідні статті.
      </PageDescription>
      <ArticlesWithFilter showAllOption={true} />
    </PageContainer>
  );
};

export default Categories;
